<template>
      <ul class="question">
        <li>
          <h1><i class="q">Q</i><span>基础自然语言处理算法的API怎么调用？</span></h1>
          <p><i class="a">A</i><span>购买服务后，可通过自己的Access Token以及服务地址进行服务的使用，具体方法请查看 <router-link :to="{path:'/apis/doc',query:{name:'ccsy'}}">《API文档》</router-link>。</span></p>
        </li>
        <li>
          <h1><i class="q">Q</i><span>提供的服务不太满足需求怎么办？</span></h1>
          <p><i class="a">A</i><span>您可以使用定制服务功能，填写您的需求，我们会同您明确需求并进行定制化开发。</span></p>
        </li>
        <li>
          <h1><i class="q">Q</i><span>Access Token如何获得？</span></h1>
          <p><i class="a">A</i><span>在注册并登录后，您可以在管控台中查看到自己的Access Key信息，从而获得Access Key ID和 Access Key Secret，通以上信息可获取Access Token，获取方法可查看 <router-link :to="{path:'/apis/doc',query:{name:'jqrz'}}">《鉴权认证机制》</router-link>，Access Token的有效期一般为15天。</span></p>
        </li>
        <slot></slot>
      </ul>
</template>

<script>
    export default {
        name: "question"
    }
</script>

<style scoped lang="less">
.question {
  margin: 0 20px;
  li {
    padding-bottom: 20px;
    border-bottom: 1px dashed #d8dee3;
    &:last-child {
      border-bottom: none;
    }
    i {
      display: block;
      width: 18px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      border-radius: 3px;
      margin-right: 10px;
      font-size: 12px;
      color: #fff;
      font-weight: 900;
    }
    h1 {
      color: #333;
      margin-top: 20px;
      margin-bottom: 10px;
      display: flex;
      .q {
        background-color: #4fbaec;
      }
      span {
        flex: 1;
      }
    }
    p {
      color: #666;
      line-height: 20px;
      display: flex;
      .a {
        width: 18px;
        background-color: #ff8e66;
      }
      a {
        color: #6366f1;
      }
      span {
        flex: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/feedBack/Question.vue